import Base from "./Base";

class List extends Base {
    static saveRowFormAsync(body) {
        return this.sendRequest("/list/save-row-form-async", "POST", {}, body);
    }

    static saveRowForm(body) {
        return this.sendRequest("/list/save-row-form", "POST", {}, body);
    }

    static getListConfig(body) {
        return this.sendRequest("/list/get-list-config", "POST", {}, body);
    }

    static getUserEvents(body) {
        return this.sendRequest("/events/get-user-events", "POST", {}, body);
    }

    static executeAction(body) {
        return this.sendRequest("/events/execute-actions", "POST", {}, body);
    }

    static addEditCell(body) {
        return this.sendRequest("/list/add-edit-cell", "POST", {}, body);
    }

    static getLookupColumnData(body) {
        return this.sendRequest("/list/get-lookup-column-data", "POST", {}, body);
    }

    static getColumnUniqueData(body) {
        return this.sendRequest("/filter/get-column-unique-data", "POST", {}, body);
    }

    static getColumnData(body) {
        return this.sendRequest("/list/get-column-data", "POST", {}, body);
    }

    static getRowData(body) {
        return this.sendRequest("/list/get-row-data", "POST", {}, body);
    }

    static getSubsheetData(body) {
        return this.sendRequest("/list/get-subsheet-data", "POST", {}, body);
    }

    static getHiddenColumnsData(body) {
        return this.sendRequest("/list/get-hidden-columns-data", "POST", {}, body);
    }

    static getCustomEvents(body) {
        return this.sendRequest("/events/get-events", "POST", {}, body);
    }

    static deleteAction(body) {
        return this.sendRequest("/list/delete-row", "POST", {}, body);
    }

    static addEditColumn(body) {
        return this.sendRequest("/list/add-edit-column", "POST", {}, body);
    }

    static getDuplicateColumnsData(body) {
        return this.sendRequest("/list/get-duplicate-columns-data", "POST", {}, body);
    }
    
    static addDropdownOption(body) {
        return this.sendRequest("/list/add-dropdown-option", "POST", {}, body);
    }

    static createSheet(body) {
        return this.sendRequest("/items/create-sheet", "POST", {}, body);
    }

    static saveListName(params) {
        return this.sendRequest('/list/save-list-name', 'POST', {}, params);
    }

    static getFormula(listId, formulaId) {
        return this.sendRequest('/list/get-formula', 'POST', {}, {
            list_id: listId,
            formula_id: formulaId,
        });
    }

    static validateFilterQuery(listIds, query) {
        return this.sendRequest('/list/validate-filter-query', 'POST', {}, {
            list_ids: listIds,
            query: query,
        });
    }

    static testCodeSnippetSyntax(listName, columnsData, formula) {
        return this.sendRequest('/list/test-formula-syntax', 'POST', {}, {
            list_name: listName,
            formula,
            columnsData
        });
    }

    static createList(parentId, listName, columnsData = [], addButtonText = "new") {
        return this.sendRequest('/list/create-list', 'POST', {}, {
            list_name: listName,
            data: columnsData,
            add_button_text: addButtonText,
            parent_id: parentId
        });
    }

    static getListTemplate(listId, isSubList) {
        return this.sendRequest('/list/get-list-template', 'POST', {}, {
            list_id: listId,
            is_sub_list: isSubList,
        });
    }

    static deleteColumn(listId, columnId) {
        return this.sendRequest('/list/delete-column', 'POST', {}, {
            list_id: listId,
            column_id: columnId,
        });
    }

    static markAsDefaultReport(view_id) {
        return this.sendRequest('/views/mark-default-view', 'POST', {}, {
            view_id: view_id
        })
    }

    static updateColorCodes(params) {
        return this.sendRequest('/color-codes/update-color-codes', 'POST', params);
    }

    static getColorCodes(params) {
        return this.sendRequest('/color-codes/get-color-codes', 'POST', params);
    }

    static getColumnConfigs(params) {
        return this.sendRequest('/list/get-column-config', 'GET', params);
    }

    static getLogs(params) {
        return this.sendRequest('/list/get-logs', 'POST', params)
    }

    static restoreLog(params){
        return this.sendRequest('/list/restore-log', 'POST', params)
    }

    static getTotalRecordsCount(params){
        return this.sendRequest('/list/get-total-records-count', 'GET', params)
    }
}

export default List;

// TL.ApiClient.Invite = new Invite();
